import { makeRPCPost } from '~api/RpcAPI/RpcAPI';
import { ICartEngraving, IKitCollection } from '~domain/entities/CartItem/ICartItem';

interface IDeleteEngraving {
    cartId: number;
    engraving: ICartEngraving;
    collection: IKitCollection;
}

export const deleteEngraving = ({
    cartId,
    engraving: { engravedSkuId, message, selectedFont, engravingType },
    collection: { id, name }
}: IDeleteEngraving) => {
    return makeRPCPost([
        {
            method: 'form.rpc',
            params: [
                {
                    _SUBMIT: 'alter_monogram',
                    cmode: 'del',
                    action: 'delete',
                    add_sku_demo: 1,
                    CART_ID: cartId,
                    SAVED_MONOGRAM_PATTERN: '',
                    SAVED_MONOGRAM_TEXT: message,
                    SAVED_MONOGRAM_FONT: selectedFont,
                    engraved_sku_id: engravedSkuId,
                    SKU_BASE_ID: engravedSkuId,
                    COLLECTION_NAME: name,
                    ENGRAVING_TYPE: engravingType,
                    COLLECTION_ID: id,
                    CART_SKU_ITEM_ID: ''
                }
            ]
        }
    ]);
};
